// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes */
export default {
  "ABOUT": "概要",
  "ABOUT_API_TAB": "API",
  "ABOUT_VERSION": "バージョン",
  "ABOUT_EXTENSIS_URL": "www.portfoliodam.com",
  "ABOUT_PORTFOLIO_SERVER": "Portfolio Server",
  "ABOUT_PORTFOLIO_VERSION": "バージョン 9.0",
  "ABOUT_SERVER_TAB": "サーバー",
  "accessOriginals": "オリジナルへのアクセスおよび処理",
  "ACCOUNT_TYPE": "認証",
  "ACCOUNT_TYPE_LDAP": "ディレクトリサービス",
  "ACCOUNT_TYPE_MANUAL": "ネイティブ (ビルドイン)",
  "ACTIVE_DIRECTORY": "Active Directory",
  "ADD": "追加",
  "ALL_CATALOGS_GROUP": "すべてのカタログ",
  "API_CODE_REFERENCE": "APIコードレファレンス (English)",
  "API_CODE_REFERENCE_URL": "https://doc.portfoliodam.com/api/portfolio/index.html",
  "API_DEVELOPER_COMMUNITY": "開発者コミュニティ",
  "API_DEVELOPER_COMMUNITY_URL": "https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community",
  "API_PORTFOLIO_HELP": "サーバ管理者ヘルプ",
  "API_PORTFOLIO_HELP_URL": "https://helpdocs.portfoliodam.com/ja/portfolio/administration/{version}/Content/Home.htm#googtrans(ja)",
  "API_SECTION_1": "開発者はポートフォリオサーバAPIを使うと、ポートフォリオサーバカタログ、アセットのメタデータ、メディアプロセッシングをビジネスシステム、カスタムワークフロー、ウェブインフラストラクチャに統合できるようになります。",
  "API_SECTION_2_PART_1": " ",
  "API_SECTION_2_EULA": "ポートフォリオサーバEULAに記述してあるとおり",
  "API_SECTION_2_EULA_URL": "https://helpdocs.portfoliodam.com/portfolio/{version}/administration/ja/Content/Legal/extensis-portfolio-eula.htm",
  "API_SECTION_2_PART_2": " 、APIの使用にはライセンスが必要です。 ライセンス情報を表示・編集するには、サーバ管理アプリケーションで［ライセンス］をクリックします。",
  "API_SECTION_2_PART_3": "開始：",
  "API_TOKEN_CREATE": "新規APIトークンを追加",
  "APPLY": "適用",
  "APP_PAGE_TITLE": "Portfolio Admin",
  "AT_TIME": "次の時刻に",
  "AUTHENTICATION_ERROR": "ディレクトリサービスの認証が失敗しました。 ユーザー名とパスワードを確認してください。",
  "BACKUP_BACKUP_BUTTON": "バックアップ",
  "BACKUP_BACKUP_LABEL": "バックアップ",
  "BACKUP_BACKUP_NOW_BUTTON": "今すぐバックアップ",
  "BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE": "バックアップの保存場所を変更するには、まずPortfolioのサーバーを終了する必要があります。",
  "BACKUP_CONFIRMATION_VERBIAGE": "今すぐバックアップしますか？バックアップが完了するまで、Portfolioはオフラインになります。",
  "BACKUP_DIRECTORY_LABEL": "ディレクトリに保存",
  "BACKUP_DIRECTORY_ERROR_MSG": "選択したバックアップディレクトリは使用できません。",
  "BACKUP_EXPLANATION_TEXT_1": "バックアップはサーバーのデータベースをキャプチャーして、安全に保存します。\nItはオリジナルファイルをバックアップしません！",
  "BACKUP_EXPLANATION_TEXT_2": "バックアップ中はサーバーに接続できません。",
  "BACKUP_FRIDAY_LABEL": "金曜日",
  "BACKUP_MONDAY_LABEL": "月曜日",
  "BACKUP_MOST_RECENT_LABEL": "最近のバックアップ",
  "BACKUP_NEXT_SCHEDULED_LABEL": "次回のバックアップ",
  "BACKUP_NOTIFICATIONS": "バックアップ/復元後にEmail通知を送信",
  "BACKUP_NOTIFICATIONS_DISABLED_MSG": "グローバル設定＞Email通知で、Email通知を有効化してください。",
  "BACKUP_PROGRESS_BACKING_UP": "バックアップ",
  "BACKUP_PROGRESS_BACKING_UP_DATA": "データをバックアップ中…",
  "BACKUP_PROGRESS_BACKUP_CANCELLED": "バックアップキャンセル",
  "BACKUP_PROGRESS_BACKUP_FAILED": "バックアップ失敗",
  "BACKUP_PROGRESS_BACKUP_SUCCESSFUL": "バックアップ成功",
  "BACKUP_PROGRESS_PREFLIGHT": "利用可能な領域をチェック",
  "BACKUP_PROGRESS_RESTARTING": "サーバーを再起動中…",
  "BACKUP_PROGRESS_RESTORE_FAILED": "復元失敗",
  "BACKUP_PROGRESS_RESTORE_SUCCESSFUL": "復元成功",
  "BACKUP_PROGRESS_RESTORING": "復元",
  "BACKUP_PROGRESS_RESTORING_DATA": "データを復元中…",
  "BACKUP_PROGRESS_SHUTTING_DOWN": "サーバーを終了中…",
  "BACKUP_PROGRESS_SUMMARY": "ステップ {stepNum}/{totalSteps}",
  "BACKUP_RESTORE_BUTTON": "バックアップファイルから復元",
  "BACKUP_RESTORE_CONFIRMATION_VERBIAGE": "今すぐバックアップを復元しますか？復元が完了するまで、Portfolioはオフラインになります。この処理は現在のデータベースと設定を上書きします。",
  "BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE": "バックアップアーカイブが破損しています。他のバックアップを選択してください。",
  "BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE": "バックアップディスクが十分ではありません。",
  "BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY": "現在のバックアップの保存先は存在しません。バックアップの保存先は、復元時にバックアップのアーカイブを解凍するのにも使用されます。有効な保存先を選択しなおしてください。",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP": "[backup/restore]に問題が発生しました。詳細は管理ログを参照してください。",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE": "[backup/restore]に問題が発生しました。詳細は管理ログを参照してください。",
  "BACKUP_RESTORE_LABEL": "復元",
  "BACKUP_RESTORE_TITLE": "バックアップ/復元",
  "BACKUP_RETAIN_LABEL": "保存",
  "BACKUP_RETAIN_VALUE": "最近の{numBackups}つのバックアップを保持",
  "BACKUP_SATURDAY_LABEL": "土曜日",
  "BACKUP_SCHEDULE_LABEL": "バックアップをスケジュール",
  "BACKUP_SCHEDULE_VALUE": "に",
  "BACKUP_SUNDAY_LABEL": "日曜日",
  "BACKUP_THURSDAY_LABEL": "木曜日",
  "BACKUP_TUESDAY_LABEL": "火曜日",
  "BACKUP_WEDNESDAY_LABEL": "水曜日",
  "BROWSE": "ブラウズ",
  "BROWSE_FOLDERS_TITLE": "サーバーフォルダ参照",
  "BROWSE_RECENT_FOLDERS_LABEL": "最近使ったフォルダ",
  "BROWSE_REFRESH": "アイテムの同期",
  "CALL_ATT_BUTTON_BUY_NOW": "購入する",
  "CALL_ATT_BUTTON_SECONDARY": "価格についてセールスにお問い合わせ",
  "CALL_ATT_FADEL_BUTTON_MAIN": "より多くの情報のための接触の販売",
  "CALL_ATT_FADEL_MAIN": "ライセンスで保護された画像やムービーなどを正しく使用する助けになります。PortfolioはFADEL Rights Cloudソフトウェアにシームレスに接続して、あなたのアセットに関連づけられている使用権を簡単に確認できるようにします。これによって、ライセンスの調査に必要な時間やコピーライトを違反するリスクを減らすことができるはずです。",
  "CALL_ATT_FADEL_SUBTITLE": "アセットの使用状況の取得",
  "CALL_ATT_FADEL_TITLE": "FADEL RIGHTS CLOUD",
  "CALL_ATT_ME_SUBTITLE": "高いパフォーマンスの処理と変換",
  "CALL_ATT_ME_MAIN": "Portfolioサーバーのパフォーマンスをさらに向上させたいですか？Media Engineがあれば、処理速度の低下を避け、処理が集中することによって発生するボトルネックを除去して、全体的な生産性を高めることができます。\n\n\t• 処理能力を向上\n\t• 追加の出力形式を使用可能\n\t• ビデオプレビューの作成を高速化\n\t• 必要に応じて複数のMedia Engineを追加\n\t• ウォーターマークを追加（NetPublishが必要です）",
  "CALL_ATT_ME_BUTTON_MAIN": "Media Engineを購入",
  "CALL_ATT_NP_SUBTITLE": "必要なアセットを簡単に見つけることができるセルフサービスのポータルサイト",
  "CALL_ATT_NP_MAIN": "アセットを使用したい人物からのいつも突然のリクエストに辟易していませんか？NetPublishがあれば、誰でもそれぞれのデバイスのブラウザから、必要なアセットを見つけてダウンロードすることができる、セルフサービスのウェブサイトを簡単に作成することができます。\n\n\t• ワンクリックでサイトを作成 - HTMLやCSSの知識は必要ありません\n\t• モバイルデバイスに適したレスポンシブデザイン\n\t• フレキシブルなユーザーアクセス制御\n\t• サイトの使用期限を設定\n\t• ダウンロード時に、解像度、サイズ、形式を設定\n\t• ウォーターマークを追加（Media Engineが必要です）\n\t• 使用状況レポート",
  "CALL_ATT_NP_BUTTON_MAIN": "NetPublishを購入",
  "CALL_ATT_REPORT_TITLE": "NetPublishレポート",
  "CALL_ATT_REPORT_SUBTITLE": "使用状況の適切な解析",
  "CALL_ATT_REPORT_MAIN": "どのサイトが最も頻繁に利用されており、どのアセットが誰に使用されているのかを知りたくはありませんか？NetPublishレポートがあれば、実際にPortfolioがどのように使用されているのかにもとづいて、あなたが根拠のある決定をするために必要な解析結果を取得することができます。\n\n次の分類による使用状況:\n\t• NetPublishサイト名\n\t• ユーザー名\n\t• アセット名とID\n\t• 日時",
  "CALL_ATT_REPORT_BUTTON_MAIN": "NetPublishを購入",
  "CALL_ATT_SK_BUTTON_MAIN": "無料体験版",
  "CALL_ATT_SK_BUTTON_TRY_NOW": "https://extens.is/wqqb",
  "CALL_ATT_SK_MAIN": "画像にキーワードを割り当てる作業を高速化したくはありませんか？Portfolio Smart Keywordsを使用すれば、「スマートな」キーワードをワンクリックで自動的に画像に割り当てることができます。この技術は、画像認識に秀でた人工知能を研究する革新的な企業であるClarifaiによって提供されています。\n\n\t・Smart Keywordsとして割り当てられるキーワードのリストはすぐに提供されます。\n\t・今までキーワードの割り当てに費やしていた時間と労力を減らすことができます。\n\t・一貫性のある最適な方法で、あなたの組織の資産となる膨大な画像を分類します。\n\t・必要なデジタルアセットを必要な時に即座に見つけることが容易になるはずです。",
  "CALL_ATT_SK_SUBTITLE": "キーワードを自動的に作成",
  "CALL_ATT_SK_TITLE": "Portfolio Smart Keywords",
  "CALL_ATT_SSO_SUBTITLE": "プラットフォームの種類に影響されない一貫したユーザーエクスペリエンス",
  "CALL_ATT_SSO_TITLE": "シングルサインオン",
  "CALL_ATT_SSO_MAIN": "ログイン認証の信頼性を維持するために、多大な労力が費やされているということはありませんか？一般的には、新しい製品の使用を開始すると、あなたとあなたのユーザーの両方のアカウントを管理するために、追加費用が必要になります。\n\n幸いなことに、Portfolioはアクティブディレクトリによるシングルサインオンをサポートしています。シングルサインオンを使用すれば、ユーザーはあなたの社内ネットワークから自動的にPortfolioにログインすることができ、連続的なユーザーエクスペリエンスの提供を受けることができます。\n\n\t• Windows Serverのアクティブディレクトリをサポート\n\t• 全体的なセキュリティを向上\n\t• ユーザーの管理を簡略化\n\t• ユーザーエクスペリエンスを向上",
  "CALL_ATT_SSO_BUTTON_MAIN": "シングルサインオンを購入",
  "CALL_ATT_URL_BUY_NOW": "https://secure.portfoliodam.com/portfolio-options",
  "CALL_ATT_URL_CONTACT_SALES": "https://portfoliodam.com/portfolio/contact-me",
  "canEmbedMetadata": "メタデータの埋め込み",
  "canImportMetadata": "データの読み込み / データの書き出し",
  "canManagePublicGallery": "パブリック ギャラリーの管理",
  "canPublishNetPublishSites": "NetPublishサイトの発行",
  "canSmartKeyword": "Smart Keywordの使用",
  "CANCEL": "キャンセル",
  "CATALOG": "カタログ",
  "CATALOG_ADD_SELECTED_USERS_TO_CATALOG": "メンバシップを与える",
  "CATALOG_BACKUP": "選択したカタログをバックアップ",
  "CATALOG_CREATE": "新規カタログを追加",
  "CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG": "カタログ管理者は、デスクトップクライアントにてオートシンクフォルダを追加できます。",
  "CATALOG_CREATE_AUTOSYNC_FOLDER": "オートシンクフォルダを作成",
  "CATALOG_CREATE_CATALOG_TEMPLATE": "カタログテンプレート",
  "CATALOG_TYPE_GENERAL": "汎用",
  "CATALOG_TYPE_SIMPLE": "簡易",
  "CATALOG_CREATE_DATABASES_LIST_LABEL": "データベース",
  "CATALOG_CREATE_ERROR_CREATING_FOLDERS": "{folder}　フォルダを作成中にエラーが発生しました。",
  "CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG": "オートシンクおよびプレビューのデフォルトフォルダは、グローバル設定で変更できます。",
  "CATALOG_CREATE_NAME": "名前",
  "CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG": "カタログ詳細にてプレビュー設定ができます。",
  "CATALOG_CREATE_PREVIEW_FOLDER": "プレビューの表示速度を向上するには、プレビューを保存します",
  "CATALOG_CREATE_SHOW_DATABASES": "データベースを表示",
  "CATALOG_CREATE_USE_VERSIONING": "アセットのバージョン管理を使用",
  "CATALOG_DELETE": "カタログを削除",
  "CATALOG_DELETE_CONFIRM": "選択したカタログを削除しますか?",
  "CATALOG_DETAILS": "カタログの詳細情報",
  "CATALOG_DETAILS_CHANGE_NAME_PROMPT": "カタログの名前を変更するには、このカタログを一時的にオフラインにする必要があります。続行しますか?",
  "CATALOG_DETAILS_COLLATION": "対象",
  "CATALOG_DETAILS_COLLATION_NA": "なし",
  "CATALOG_DETAILS_CREATION_DATE": "作成日",
  "CATALOG_DETAILS_DATABASE_TAB": "一般",
  "CATALOG_DETAILS_LAST_MODIFIED": "最終修正日",
  "CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS": "接続しているユーザー",
  "CATALOG_DETAILS_NUMBER_OF_RECORDS": "レコード",
  "CATALOG_DETAILS_NUMBER_OF_USERS": "メンバ",
  "CATALOG_DETAILS_SIZE_ON_DISK": "ディスク上のサイズ",
  "CATALOG_DETAILS_WARN_DISCONNECT_ADMIN": "管理者ユーザーの接続を解除します。続行してよろしいですか?",
  "CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION": "管理用にロック",
  "CATALOG_DETAILS_UNLOCK": "ロック解除",
  "CATALOG_EXPLANATION_VAULT_1": "Vaultカタログはアセットを安全なリポジトリに保管します。",
  "CATALOG_EXPLANATION_VAULT_2": "Vaultカタログは、ロック、バージョン管理、チェックアウトおよびチェックインをサポートします。",
  "CATALOG_EXPLANATION_WF_1": "監視フォルダカタログはアセットの元の場所を参照します。",
  "CATALOG_EXPLANATION_WF_2": "監視フォルダカタログはオートシンクをサポートします。",
  "CATALOG_INGEST_DRAG_HINT_TEXT": "アップロードフォームにフィールドを追加するには、フィールドリストからドラッグしてください。",
  "CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL": "アップロードフォームのフィールド",
  "CATALOG_INGEST_FIELDS_LABEL": "フィールド",
  "CATALOG_INGEST_FORM_HEADER_LABEL": "フォームヘッダー",
  "CATALOG_INGEST_HEADER_HINT_TEXT": "フォームヘッダーは、フォームの一番上に表示されるオプションです。",
  "CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE": "フォームに追加できるフィールドの最大数は{maxFields}です。",
  "CATALOG_INGEST_TAB_TITLE": "管理されたアップロード",
  "CATALOG_INGEST_USE_INGEST_LABEL": "管理されたアップロードを使用",
  "CATALOG_INGEST_REQUIRED_LABEL": "必須",
  "CATALOG_IS_CONNECTED": "接続済み",
  "CATALOG_IS_DEFAULT": "デフォルト",
  "CATALOG_MANAGE_USERS": "カタログのメンバシップを管理",
  "CATALOG_MANAGE_FIELDS": "カタログフィールドの管理",
  "CATALOG_MANAGE_TEMPLATES_MENU_LABEL": "カタログテンプレートを管理",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE": "カスタムカタログテンプレートを管理",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER": "カタログテンプレート名",
  "CATALOG_MEMBER": "メンバ",
  "CATALOG_NEW_CATALOG_DETAILS": "新規カタログの詳細情報",
  "CATALOG_OFFLINE": "オフライン",
  "CATALOG_ONLINE": "オンライン",
  "CATALOG_OPTIONS_ALL_FILE_TYPES": "全てのファイルタイプをカタログ化",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL": "パスからキーワードを作成",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME": "ファイル名",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT": "上位フォルダ",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER": "サーバー名",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE": "フォルダ構造",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME": "ボリューム",
  "CATALOG_OPTIONS_EXCLUSION_LABEL": "除外するファイルとフォルダ",
  "CATALOG_OPTIONS_ONLY_FILE_TYPES": "次のファイルタイプのみカタログ化",
  "CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION": "選択したファイルタイプを削除しますか？",
  "endsWith": "で終わる",
  "contains": "含む",
  "startsWith": "で始まる",
  "CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION": "選択した除外を削除しますか？",
  "CATALOG_OPTIONS_TAB_TITLE": "カタログ作成オプション",
  "CATALOG_PREVIEWS_DEFAULT_LOCATION_IS": "デフォルトの場所",
  "CATALOG_PREVIEWS_DIMENSIONS_LABEL": "最小サイズ300ピクセル、最大サイズ4000ピクセル（長辺）",
  "CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES": "オーディオ/ビデオファイルのクリップを作成",
  "CATALOG_PREVIEWS_GENERATE_PREVIEWS": "プレビューを作成",
  "CATALOG_PREVIEWS_FOLDER_LOCATION": "プレビューとクリップを次のフォルダに保存",
  "CATALOG_PREVIEWS_LOCATION_WARNING_INFO": "サーバーから参照可能な場所に指定する必要があります。",
  "CATALOG_PREVIEWS_MAX_PIXELS": "最大画像サイズ",
  "CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION": "最大動画解像度",
  "CATALOG_PREVIEWS_MINUTES": "分",
  "CATALOG_PREVIEWS_PIXELS": "ピクセル",
  "CATALOG_PREVIEWS_SHORT": "プレビュー",
  "CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION": "時間制限",
  "CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT": "クリップの作成には時間がかかります。\n処理時間を短縮するには解像度と継続時間の値を下げてください。",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG": "メンバシップを取り消し",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION": "カタログからユーザーを削除しますか？\nユーザーのこのカタログのチェックアウトアイテムが復帰して、アクセス可能になります。",
  "CATALOG_SAVE_TEMPLATE": "カタログテンプレートを保存",
  "CATALOG_SAVE_TEMPLATE_DETAILS_TEXT": "保存したテンプレートには、フィールド、メタデータのマッピング、カタログ作成オプションの設定が含まれています。",
  "CATALOG_SELECT_MESSAGE": "カタログ未選択",
  "CATALOG_SET_AS_DEFAULT": "デフォルトカタログを設定",
  "CATALOG_SK_DEFAULT_SETTINGS": "デフォルト設定",
  "CATALOG_SK_CONFIDENCE_LEVEL_LABEL": "精度",
  "CATALOG_SK_DEFAULT_LABEL": "推奨: {recommended}",
  "CATALOG_SK_ENGINES_LABEL": "Smart Keywordエンジン",
  "CATALOG_SK_LANGUAGES_LABEL": "General Engineの言語",
  "CATALOG_SK_NUM_KEYWORDS_LABEL": "キーワード数",
  "CATALOG_SK_SETTINGS_LABEL": "設定",
  "CATALOG_SK_TAB_TITLE": "Smart Keywords",
  "CATALOG_SK_USE_SK_LABEL": "このカタログでSmart Keywordsを使用",
  "CATALOG_STATUS": "カタログの状態",
  "CATALOG_STORAGE_TYPE_LABEL": "ストレージタイプ",
  "CATALOG_STORAGE_TYPE_WATCHFOLDERS": "監視フォルダ",
  "CATALOG_STORAGE_TYPE_VAULT": "Vault",
  "CATALOG_TAKE_OFFLINE_SHORT": "オフラインにする",
  "CATALOG_TAKE_ONLINE_SHORT": "オンラインにする",
  "CATALOG_TEMPLATE": "テンプレート",
  "CATALOG_TEMPLATE_NAME": "テンプレート名",
  "CATALOG_TEMPLATES_TITLE": "カタログテンプレート",
  "CATALOG_TEMPLATE_REMOVE_CONFIRMATION": "選択したカタログテンプレートを削除しますか？",
  "CATALOG_VIEW_DETAILS": "カタログ詳細情報を表示/編集",
  "CERT_REQUEST_ALREADY_CREATED_WARNING": "証明書リクエストは既に作成されています。続行すると既存のリクエストは削除されます。",
  "CERTIFICATE_FILE_FILTER": "証明書 (p7b, p7, cer, crt, pem, pfx, p12)",
  "CITY_OR_LOCALITY": "市または地域",
  "CLEAR_BUTTON_LABEL": "消去",
  "COMMUNICATION_AT_INITILIZATION_ERROR": "サーバー接続時にエラー。これはブラウザのキャッシュに含まれる古いデータが原因になることが良くありますが、サーバー側の問題の可能性もあります。詳細な情報については管理者にお問い合わせください。",
  "CONFIGURE_DIRECTORY_SERVICE": "ディレクトリサービスを設定",
  "CONFIRM_DELETE_PDL": "全ての定義済みの値を削除しますか？",
  "CONFIRM_DELETE_SERVICE": "ディレクトリサービスを削除しますか?\nサービスからインポートされたユーザは残ります。 これらのユーザのパスワードは、以前 Portfolio で設定された値に戻ります。以前設定されていない場合は無効になります。",
  "CONFIRM_TRUNCATE_VALUES": "最大の長さが、デフォルト値か定義済みの値の一つ以上を超えています。値を切り捨てますか？",
  "CONNECTION_REFUSED_ERROR": "ディレクトリサービスへの接続が拒否されました。 ホスト名とポートの設定を確認してください。",
  "CONTAINS": "を含む",
  "CONTINUE": "続ける",
  "CREATE": "作成",
  "CREATE_A_CERTIFICATE_REQUEST": "証明書署名リクエストを作成",
  "createContactSheet": "PDF 作成",
  "CREATED_BY": "作成者",
  "CREATE_MAPPING": "マッピングを作成",
  "CREATE_USER_EXCLUSION_MAPPING": "ユーザーを除外",
  "CREATED_ON_DATE": "作成日",
  "DATE_FORMAT": "YYYY-MM-DD",
  "DATE_FORMAT_ERROR": "設定エラー：不正な形式の文字列です。",
  "DATE_INVALID_CHAR_ERROR": "使用できない文字が含まれています。",
  "DATE_TIME_FORMAT": "YYYY-MM-DD L:NN A",
  "DATE_TIME_SECONDS_FORMAT": "YYYY-MM-DD L:NN:SS A",
  "DATE_WRONG_DAY_ERROR": "有効な日付を入力してください。",
  "DATE_WRONG_LENGTH_ERROR": "日付を入力してください。",
  "DATE_WRONG_MONTH_ERROR": "1〜12の月を入力",
  "DATE_WRONG_YEAR_ERROR": "0〜9999の年を入力",
  "DEFAULT_ACCESS_LEVEL": "デフォルトの役割",
  "DEFAULT_CATALOG": "デフォルトカタログ",
  "DEFAULT_CATALOG_NONE": "なし",
  "DEFAULT_PORT_NON_SSL": "非SSL用のデフォルトポート:",
  "DEFAULT_PORT_SSL": "SSL用のデフォルトポート:",
  "DELETE": "削除",
  "DELETE_SOURCE": "ソースを削除",
  "DELETE_ALL_NESTED_VALUES_CONFIRMATION": "全ての値を削除しますか？ネスト化された値も全て削除されます。",
  "DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION": "{value}'の値を削除しますか？\nネスト化された値も削除されます。",
  "DELETE_NESTED_VALUE_CONFIRMATION": "選択した値を削除しますか？",
  "DELETE_WARNING_BOX_MSG": "警告 いったん削除を実行すると、操作を取り消すことはできません!",
  "DELETE_WARNING_CATALOG_VAULT": "カタログのすべてのファイルは破壊される。",
  "DIAGNOSTIC_DATA_TITLE": "Portfolio DAMに診断レポートを送信",
  "DIAGNOSTIC_DATA_ACCOUNT_NAME": "会社名（必須）",
  "DIAGNOSTIC_DATA_CONTACT_NAME": "担当者名",
  "DIAGNOSTIC_DATA_TS_TICKET_NUMBER": "テクニカルサポートチケット番号",
  "DIAGNOSTIC_DATA_SEND_REPORT_BUTTON": "レポートを送信",
  "DIAGNOSTIC_STATUS_ERROR": "{date} の診断レポートをアップロード中に問題が発生しました。",
  "DIAGNOSTIC_STATUS_SENDING": "発送...",
  "DIAGNOSTIC_STATUS_SUCCESS": "{date} にPortfolio DAMへ正しく送信された診断レポート",
  "DIRECTORY_SERVICE_CONNECT_ERROR": "ディレクトリサービスに接続できません。 ホスト名とポートの設定を確認してください。",
  "DIRECTORY_SERVICES": "ディレクトリサービス",
  "DIRECTORY_USERS_CANNOT_BE_DELETED": "ディレクトリサービスのユーザーは削除できません。",
  "DISTRIBUTION_GROUPS": "配布グループ",
  "DOWNLOAD_CERT_PROMPT": "証明書リクエストファイルをダウンロードしますか？",
  "DOWNLOAD_COMPLETE_STRING": "ダウンロード完了",
  "downloadPreviews": "プレビューをダウンロード",
  "EMAIL_ADDRESS": "電子メールアドレス",
  "EMAIL_CONFIG_AUTH_PASSWORD": "パスワード",
  "EMAIL_CONFIG_AUTH_USERNAME": "ユーザー名",
  "EMAIL_CONFIG_ENABLED": "Email通知を有効化",
  "EMAIL_CONFIG_FROM_ADDRESS": "差出人Emailアドレス",
  "EMAIL_CONFIG_INVALID_GENERIC": "Emailサーバーの設定が無効です",
  "EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND": "Emailサーバーが見つかりません",
  "EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED": "Emailサーバーの認証に失敗しました",
  "EMAIL_CONFIG_MESSAGE": "通知を受け取りたいユーザーのEmailアドレスをユーザーパネルで設定してください。",
  "EMAIL_CONFIG_SERVER_ADDRESS": "SMTPサーバーアドレス",
  "EMAIL_CONFIG_SERVER_PORT": "SMTPサーバーポート",
  "EMAIL_CONFIG_SUCCESS_MESSAGE": "SMTPサーバーが有効です",
  "EMAIL_CONFIG_USE_SSL_TLS": "SSL/TLSを使用",
  "EMAIL_CONFIG_USE_SMTP_AUTH": "SMTP認証を使用",
  "EMAIL_CONFIG_VALIDATE": "接続テスト",
  "EMAIL_CONFIG_VALIDATED": "Emailサーバーが有効です",
  "english": "英語",
  "ENTIRE_TREE_UNDER_SEARCH_BASE": "検索ベース内のツリー全体",
  "EQUALS": "等しい",
  "EXPORT_MENU_STRING": "値の書き出し",
  "FADEL_HOWTO": "FADELのアカウントへのログイン:",
  "FALSE_LABEL": "偽の",
  "FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR": "管理サーバーがローカルコンピュータ上で動作しており、ポートページで表示されているポートを使っていることを確認してください。 そのようになっていない場合は、サーバーを再起動し、このアプリケーションを再び読み込んでください。",
  "FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS": "この処理は、バックアップ中もしくは復元中には行えません。",
  "FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE": "カタログが管理者モードになっているため、この操作を行うことができません。",
  "FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME": "この名前のカタログはすでに存在します。",
  "FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME": "このアカウント名のユーザーはすでに存在しています。",
  "FAULT_MSG_DB_IN_USE": "現在、管理者がカタログを使用しているため、この操作を完了することができません。",
  "FAULT_MSG_DELETE_ADMIN": "管理者アカウントを削除することはできません。",
  "FAULT_MSG_DELETE_SELF": "自分のユーザーアカウントを削除することはできません。",
  "FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR": "カタログテンプレートの削除に予期しないエラーが発生しました。",
  "FAULT_MSG_DUPE_NAME": "この名前のオブジェクトはすでに存在します。 他の名前を使ってください。",
  "FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS": "このアドレスとポート番号を使っている Media Engine はすでに存在します。",
  "FAULT_MSG_ENTITY_VERSION_MISMATCH": " クライアント情報が古いため、この操作を行うことができません。",
  "FAULT_MSG_IDENT_SERVICE_CREATION_ERROR": "サーバーがローカルコンピュータ上で動作しており、ポートページで表示されているポートを使っていることを確認してください。 そのようになっていない場合は、サーバーを再起動し、このアプリケーションを再び読み込んでください。",
  "FAULT_MSG_INVALID_SESSION_ID": "セッションが時間切れになりました。 もう一度サーバーにログインしてください。",
  "FAULT_MSG_IS_NOT_LICENSED": "この操作を行うのに必要なライセンスがサーバーにありません。",
  "FAULT_MSG_LEGACY_21000": "不明な内部エラーが発生したため、この操作に失敗しました。",
  "FAULT_MSG_LOGGING_ERR_UPDATE": "ログ設定の更新時にエラーが発生しました",
  "FAULT_MSG_LOG_DIR_NOT_VALID": "指定されたログディレクトリは存在しないか、指定されたパスはディレクトリではありません。",
  "FAULT_MSG_NO_DIRECTORY": "指定された場所は存在しないか、ディレクトリではありません。",
  "FAULT_MSG_NULL_DESCRIPTION": "予期しないエラーが発生しましたが、内容は不明です。",
  "FAULT_MSG_NULL_FAULTEVENT": "予期しないエラーが発生しましたが、詳細は不明です。",
  "FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES": "十分なアクセス権がないため、この操作を行うことができません。",
  "FAULT_MSG_OPERATION_IS_INVALID": "不正な操作です。",
  "FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR": "カタログテンプレート名の変更に予期しないエラーが発生しました。",
  "FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR": "カタログテンプレートの保存に予期しないエラーが発生しました。",
  "FAULT_MSG_SERVER_NOT_RUNNING": "サーバーが動作していません。",
  "FAULT_MSG_ENTERPRISE_NOT_LICENSED": "Enterprise Module ライセンスが見つからないため処理に失敗。",
  "FAULT_MSG_REMOVE_METADATA_DEF": "メタデータの定義の削除に失敗しました。他のカタログで使用中の可能性があります。",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT": "サーバーがエラーを返しました。メッセージ内容:",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE": "サーバーがエラーを返しました。エラーメッセージはありません。",
  "FAULT_MSG_UNHANDLED_UNKNOWN_FAULT": "サーバーが不明な種類のエラーを返しました。メッセージ内容:",
  "FAULT_MSG_UNKNOWN_SMTP_SERVER": "指定されたEmailサーバーに接続できません。",
  "FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING": "サービスが、なっているはずの状態にないため、この操作を行うことができません。",
  "FAULT_MSG_INVALID_LOGINID_OR_PASSWORD": "データベースに提供されたユーザ名またはパスワードは無効です。",
  "FAULT_MSG_BAD_DB_PORT": "データベースのポートは無効です。",
  "FAULT_MSG_BAD_DB_HOST": "データベースのホスト名またはポートの設定が無効です。",
  "FIELD_ACTION_ADD": "新しいカスタムフィールドを追加",
  "FIELD_ACTION_DELETE": "選択したフィールドを削除",
  "FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES": "XMP名前スペース",
  "FIELD_ACTION_MANAGE_METADATA": "メタデータの管理",
  "FIELD_CATEGORY_CUSTOM": "カスタムフィールド",
  "FIELD_CATEGORY_SYSTEM": "システムフィールド",
  "FIELD_CATEGORY_EXIF": "EXIF",
  "FIELD_CATEGORY_IPTC": "IPTC",
  "FIELD_CATEGORY_XMP": "XMP",
  "FIELD_CATEGORY_MOVIE": "ムービー",
  "FIELD_CATEGORY_OFFICE": "MS Office",
  "FIELD_CATEGORY_GEO": "GEO",
  "FIELD_CATEGORY_LABEL": "フィールドカテゴリー",
  "FIELD_DISABLE_CONFIRM_MSG": "選択したフィールドを無効にしますか？",
  "FIELD_ENABLE_ALL_CATEGORIES_LABEL": "すべて許可",
  "FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING": "抽出マッピングを追加",
  "FIELD_FORM_LABEL_DEFAULT_VALUE": "デフォルト値",
  "FIELD_FORM_LABEL_DISABLED": "（禁止）",
  "FIELD_FORM_LABEL_EMBED": "メタデータの埋め込み",
  "FIELD_FORM_LABEL_EXTRACT": "メタデータの抽出",
  "FIELD_FORM_LABEL_FIELD_NAME": "フィールド名",
  "FIELD_FORM_LABEL_FIELD_TYPE": "フィールドタイプ",
  "FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES": "複数の値を許可",
  "FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES": "定義済みの値を保持",
  "FIELD_FORM_LABEL_HELP_TEXT": "ヘルプテキスト",
  "FIELD_FORM_LABEL_MAX": "最大：{max}",
  "FIELD_FORM_LABEL_MAX_LENGTH": "最大の長さ",
  "FIELD_FORM_LABEL_METADATA_TAG": "メタデータ名",
  "FIELD_FORM_LABEL_METADATA_TYPE": "メタデータタイプ",
  "FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES": "定義済みの値のみ許可",
  "FIELD_FORM_LABEL_PRECISION": "精度",
  "FIELD_FORM_LABEL_PREDEFINED_VALUES": "定義済みの値",
  "FIELD_FORM_LABEL_SHOW_TIME": "時刻の表示",
  "FIELD_FORM_LABEL_USE_METADATA": "メタデータの抽出と埋め込み",
  "FIELD_FORM_WARNING_DUPE_EMBEDS": "警告：複数のフィールドが '{metadata}' に埋め込まれます",
  "FIELD_METADATA_DATA_TYPE_LABEL": "データの種類",
  "FIELD_METADATA_DEFINITION_IS_CUSTOM": "カスタム",
  "FIELD_METADATA_DEFINITIONS_TITLE": "メタデータの定義",
  "FIELD_METADATA_DELETE_CONFIRM_MSG": "確認：メタデータの定義を削除しますか？",
  "FIELD_METADATA_MULTIVALUED_TYPE_LABEL": "複数の値を許可されたタイプ",
  "FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL": "単一の値のみ許可",
  "FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL": "整列",
  "FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL": "整列なし",
  "FIELD_METADATA_NAME_LABEL": "名前",
  "FIELD_METADATA_NAMESPACE_LABEL": "名前スペース",
  "FIELD_METADATA_NEW_NAMESPACE_TOOLTIP": "カスタムXMP名前スペースの追加",
  "FIELD_METADATA_TAG_LABEL": "タグ",
  "FIELD_METADATA_TYPE_LABEL": "タイプ",
  "FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE": "複数のフィールドが選択されています。",
  "FIELD_NAMESPACE_ABBREVIATION": "省略",
  "FIELD_NAMESPACE_REMOVE_CONFIRMATION": "カスタムXMP名前スペースを削除しますか？\n名前スペースを使用したフィールドの定義が存在している可能性があります。",
  "FIELD_NAMESPACE_URI": "名前スペースURI",
  "FIELD_NEW_FIELD_NAME": "新しいフィールド",
  "FIELD_NEW_METADATA_TITLE": "新しいメタデータの定義",
  "FIELD_NEW_NAMESPACE_TITLE": "新しいカスタムXMP名前スペース",
  "FIELD_NO_FIELD_SELECTED_MESSAGE": "フィールドが選択されていません。",
  "FIELD_PAGE_TITLE": "カタログ'{catalogName}'のフィールドの管理",
  "FIELD_REVERT_CONFIRM_MSG": "確認：フィールドを元に戻しますか？",
  "FIELD_TYPE_BLOB": "BLOB",
  "FIELD_TYPE_BOOLEAN": "論理",
  "FIELD_TYPE_DATETIME": "日付/時刻",
  "FIELD_TYPE_DECIMAL": "少数",
  "FIELD_TYPE_LANG_ALT": "言語",
  "FIELD_TYPE_NUMBER": "数値",
  "FIELD_TYPE_PICTURE": "写真",
  "FIELD_TYPE_STRING": "文字列",
  "FIELD_TYPE_STRUCTURE": "構造",
  "FIELD_TYPE_TEXTBLOCK": "テキストブロック",
  "FIELD_TYPE_UNKNOWN": "未定義",
  "FIELD_TYPE_URL": "URL",
  "FILE_IO_ERROR_MSG": "サーバーへのファイルアップロードにエラーがありました。",
  "FILE_WRONG_TYPE_ERROR_MSG": "このファイル形式はサポートされていません。.jpegまたは.gif、.pngファイルを選択してください。",
  "FOLDER_PATH_AUTOSYNC_FILES_STRING": "ファイル",
  "FOLDER_PATH_ALREADY_EXIST_AS_FILE": "同名ファイルが存在します。",
  "FOLDER_PATH_DOES_NOT_EXIST": "パスは存在しません。",
  "FOLDER_PATH_ERROR": "エラー",
  "FOLDER_PATH_NOT_VERIFIED": "フォルダパスは未確認です。",
  "FOLDER_PATH_PATH": "パス",
  "FOLDER_PATH_OPERATION_INVALID": "無効な処理",
  "FOLDER_PATH_SUCCESS": "成功",
  "FOLDER_PATH_TYPE_AUTOSYNC": "オートシンク",
  "FOLDER_PATH_TYPE_PREVIEW": "プレビュー",
  "FOLDER_PATH_UNKNOWN_FAULT": "原因不明の失敗",
  "french": "フランス語",
  "FULL_NAME": "フルネーム",
  "FULLY_QUALIFIED_DOMAIN_NAME": "完全なドメイン名（FQDN）",
  "german": "ドイツ語",
  "GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL": "新規カタログのオートシンクフォルダを次のフォルダ内に作成",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR": "背景カラー",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP": "ログイン画面の背景カラー",
  "GLOBAL_SETTINGS_CATALOG_DEFAULTS": "デフォルトカタログ",
  "GLOBAL_SETTINGS_CHOOSE_FILE": "ファイルを選択",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE": "カスタムイメージ",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT": "適切なサイズは2400 x 13500ピクセル内です。",
  "GLOBAL_SETTINGS_CUSTOM_TITLE": "カスタムタイトル",
  "GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP": "このタイトルはブラウザタブやブックマークに表示されます。",
  "GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN": "カスタマイズされたログイン画面",
  "GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL": "デフォルトの役割",
  "GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN": "初期ログイン画面",
  "GLOBAL_SETTINGS_EMAIL_CONFIGURATION": "Email通知",
  "GLOBAL_SETTINGS_FADEL": "FADEL Rights Cloud",
  "GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG": "オートシンクフォルダとプレビューフォルダの場所は、サーバーからアクセスできなければなりません。",
  "GLOBAL_SETTINGS_IMAGE_URL": "リンク",
  "GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP": "画像をクリックして他のブラウザウィンドウ内でこのURLを表示します。",
  "GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG": "変更するには、サーバーを起動するか、期限切れのサーバーライセンスをチェックしてください。",
  "GLOBAL_SETTINGS_PREVIEW_PATH_LABEL": "新規カタログのプレビューを次のフォルダ内に保存",
  "GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS": "サーバーデータの場所",
  "GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION": "ログインのカスタマイゼーション",
  "GLOBAL_SETTINGS_SSO_CREDENTIALS": "シングルサインオン証明書",
  "GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP": "ケルベロス認証を利用しているPortfolio Serverサービスに関連づけられたユーザーアカウントを入力してください。",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL": "一時作業フォルダ",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG": "作業フォルダは次回のサーバー起動時には変更されます。新しいフォルダは次の場所に作成されます:",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG": "設定の変更を有効にするには、サーバーを再起動する必要があります。",
  "GLOBAL_SETTINGS_VAULT_CONFIGURATION": "Portfolio Vault設定",
  "GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL": "Portfolio Vaultフォルダ:",
  "SERVER_DATA_DEFAULT_VAULT_LOCATION_IS": "Portfolio Vaultのデフォルトの場所:",
  "GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE": "Portfolio Vaultを移動するには、まずサーバーを終了する必要があります。",
  "HELP_URL": "https://helpdocs.portfoliodam.com/ja/portfolio/administration/{version}/Content/Home.htm#googtrans(ja)",
  "HELP_URL_FADEL": "https://helpdocs.portfoliodam.com/portfolio/{version}/administration/ja/Content/03_Catalogs/05_FADEL.htm",
  "HOSTNAME": "ホスト名",
  "IDENTITY_SERVICE_DEFAULT_ROLE_STRING": "(デフォルト)",
  "IDENTITY_SERVICE_SUCCESSFUL_CREATION": "ディレクトリサービスの接続に成功。設定は保存されました。",
  "IMAGE_FILE_FILTER": "画像 (jpg, gif, png)",
  "IMPORT_LDAP": "LDAP/AD サーバーからユーザーをインポート",
  "IMPORT_LDAP_SPECIFY_SERVER": "LDAP/AD サーバーを指定",
  "IMPORT_MENU_STRING": "値の読み込み",
  "IMPORT_SOURCE": "ソースをインポート",
  "INVALID_DN_SYNTAX_ERROR": "指定した DN の形式に誤りがあるため (Invalid DN syntax)、ディレクトリサービスに接続できません。 ユーザー名を確認してください。",
  "japanese": "日本語",
  "LAST_CERTIFICATE_REQUEST_LABEL": "最終証明書リクエスト",
  "LAST_MODIFIED_BY": "最終修正者",
  "LAST_MODIFIED_DATE": "最終修正日",
  "LDAP_ADDRESS": "LDAP/AD サーバーのアドレス",
  "LDAP_BIND_USERNAME": "LDAP バインドユーザー名",
  "LDAP_SYNC_NOTIFICATION": "サーバーは同期要求を受信しました。",
  "LIC_ADD_MESSAGE": "ライセンスをコピー＆ペーストするか、1列ずつ個別に入力してください。",
  "LIC_ADD_SN": "新規ライセンスを追加",
  "LIC_ADD_SN_SHORT": "ライセンスを追加",
  "LIC_ASSET_CAP_DISPLAY": "アセット",
  "LIC_DAYS_REMAINING": "（残り {days} 日）",
  "LIC_DEMO_PERIOD": "試用期間",
  "LIC_ERROR_MSG": "不正なシリアル番号です。やり直してください。問題が回避できない場合は、サーバーのログを確認するか、管理者に連絡してください。",
  "LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG": "シリアル番号をPortfolio Studioに追加することができません。",
  "LITE_CANNOT_CREATE_FDB_CATALOG": "お持ちのライセンスでは、カタログをこれ以上増やすことはできません。アップグレードをご検討ください。",
  "LITE_CANNOT_SERVE_FDB_CATALOG": "この Portfolio Server ライセンスでは、これ以上オンラインでカタログ作成できません。",
  "LITE_THIS_FEATURE_NOT_SUPPORTED": "この Portfolio Server ライセンスでは、処理をサポートしていません。",
  "LOGGING_CONFIGURATION": "ログ設定",
  "LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE": "ログの保存場所を変更するには、まずPortfolioのサーバーを終了する必要があります。",
  "LOGGING_DEFAULT_LOCATION_MSG": "デフォルトの場所",
  "LOGGING_DIR_MUST_EXIST": "注意: ログディレクトリを正しく変更するには、既に新しいディレクトリが存在している必要があります。",
  "LOGGING_LOG_DIR": "ログディレクトリ",
  "LOGGING_LOG_LEVEL": "ログレベル:",
  "LOGGING_NUM_LOGS_TO_RETAIN": "保存するログ数",
  "LOGIN": "ログイン",
  "MAPPING_HEADER": "Portfolio ユーザー/グループのマッピング",
  "MAPPINGS_HAVE_BEEN_MODIFIED_ALERT": "マッピングが変更されました。保存しますか?",
  "MEDIA_ENGINES_ACTION_ADD": "新規 Media Engine を追加",
  "MEDIA_ENGINES_ACTION_DELETE": "Media Engine を削除",
  "MEDIA_ENGINES_ACTION_EDIT": "Media Engine 詳細情報を表示/編集",
  "MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE": "お持ちの Portfolio Media Engine ライセンスで指定された最大数の Media Engine がサーバーでアクティブになっているため、新たな Media Engine をアクティブにすることができません。",
  "MEDIA_ENGINES_CANT_ADD_NO_LICENSES": "利用可能な Portfolio Media Engine ライセンスがサーバーにないため、Media Engine を追加することはできません。",
  "MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER": "Media Engine でこのビルドを削除することはできません。",
  "MEDIA_ENGINES_COLUMN_ACTIVE": "使用可能",
  "MEDIA_ENGINES_COLUMN_ADDRESS": "アドレス",
  "MEDIA_ENGINES_COLUMN_PORT": "ポート",
  "MEDIA_ENGINES_CONFIRM_DELETE": "選択したメディアエンジンを削除しますか?",
  "MEDIA_ENGINES_EDIT_DETAILS_HEADER": "Media Engine の詳細情報",
  "MEDIA_ENGINES_LICENSES_LABEL": "Media Engine のアクティベーションに利用可能",
  "MEDIA_ENGINES_NEW_DETAILS_HEADER": "新規 Media Engine の詳細情報",
  "MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE": "動作している Media Engine がありません。 Portfolio Media サービスを使用するには、Media Engine を開始する必要があります。",
  "MOBILE": "モバイル",
  "MOBILE_ENABLED": "モバイルアップロードを有効",
  "MOBILE_FOLDER_VERBIAGE": "モバイルアップロードをこのフォルダに保存:",
  "MOBILE_CREATE_CATALOG_VERBIAGE": "このフォルダを自動監視する新規カタログ「モバイルアップロード」を作成（推奨）",
  "MOBILE_CATALOG_NAME": "モバイルアップロード",
  "modifyAssetContents": "アセットのチェックアウト",
  "MODIFY_LDAP": "LDAP クエリーを変更",
  "NAME": "名前",
  "NAME_TOO_LONG_ERROR": "名前は 1 バイト文字換算で 256 文字未満にしてください",
  "NAV_ABOUT": "バージョン情報",
  "NAV_ACCESS_LEVELS": "役割",
  "NAV_AUTOSYNC": "オートシンク",
  "NAV_BACKUPS": "バックアップ/復元",
  "NAV_CATALOGS": "カタログ",
  "NAV_GLOBAL_SETTINGS": "グローバル設定",
  "NAV_HELP": "ヘルプ",
  "NAV_LICENSES": "ライセンス",
  "NAV_LOGOUT": "ログアウト",
  "NAV_MEDIA_ENGINES": "Media Engine",
  "NAV_NETPUBLISH_SETTINGS": "NetPublish",
  "NAV_PORTS": "ポート",
  "NAV_REPORTING": "レポート作成",
  "NAV_SETTINGS": "設定",
  "NAV_STATUS": "ステータス",
  "NAV_USERS": "ユーザー",
  "NO_CATALOGS": "なし",
  "NO_FILE_SELECTED": "ファイルが選択されていません",
  "VaultFolderNotFound": "Portfolio Vaultフォルダが {path} にありませんでした。",
  "NO_VAULT_FOLDER": "Portfolio Vaultフォルダが {path} にありませんでした。フォルダの実際の場所と、グローバル設定のサーバーデータページを確認してください。",
  "NOTES": "メモ",
  "NUMBER_DECIMAL_POINT_COUNT_ERROR": "小数点は一度だけ使用できます。",
  "NUMBER_EXCEEDS_MAX_ERROR": "入力した数値が大きすぎます。",
  "NUMBER_INTEGER_ERROR": "数値は整数である必要があります。",
  "NUMBER_INVALID_CHAR_ERROR": "不正な文字が含まれています。",
  "NUMBER_INVALID_FORMAT_CHARS_ERROR": "形式のパラメータの一つが不正です。",
  "NUMBER_LOWER_THAN_MIN_ERROR": "合計が小さすぎます。",
  "NUMBER_NEGATIVE_ERROR": "合計がマイナスの可能性があります。",
  "NUMBER_PRECISION_ERROR": "小数点以下の桁数が多すぎます。",
  "NUMBER_SEPARATION_ERROR": "桁区切り文字は三桁ごとに入力してください。",
  "OK": "OK",
  "ON_DATE": "に",
  "OPEN_DIRECTORY": "Open Directory",
  "OPEN_DIRECTORY_GROUPS": "グループ",
  "ORGANIZATION_NAME": "組織名",
  "ORGANIZATIONAL_UNIT": "部門名",
  "PASSWORD": "パスワード",
  "PASSWORD_CONFIRM": "パスワードの確認",
  "PASSWORD_TOO_LONG_ERROR": "パスワードは 1 バイト文字換算で 256 文字未満にしてください",
  "PORT": "ポート",
  "PORT_VALUE_TOO_HIGH_ERROR": "ポートの値は、65536以下である必要があります。",
  "PortfolioAssetCap": "Portfolioアセット容量",
  "PortfolioAPI": "Portfolio API",
  "PortfolioDemo": "デモ",
  "PortfolioDirServices": "Portfolioディレクトリサービス",
  "PortfolioServer": "Portfolio Server",
  "PortfolioStudio": "Portfolio Studioエディション",
  "PortfolioProfessional": "Portfolio Professionalエディション",
  "PortfolioEnterprise": "Portfolio Enterpriseエディション",
  "PortfolioMediaEngine": "Portfolio Media Engine",
  "NetPublish": "Portfolio NetPublish",
  "PortfolioMobile": "Portfolio Flow",
  "PortfolioSmartKeywords": "Portfolio Smart Keywords",
  "PortfolioUserConnection": "Portfolio User接続",
  "PortfolioSingleSignOn": "シングルサインオン（SSO）",
  "PORT_CURRENT_VALUE": "現在の値",
  "PORT_ERROR_MSG_BAD_PORT_VALUE": "新しいポート番号は、1～65535 の数値で入力してください。",
  "PORT_ERROR_MSG_CONFLICT": "サーバーですでに使用されているポート番号が指定されたため、ポート番号を変更することができません。",
  "PORT_FIND_PORT": "ポートを検索",
  "PORT_NAME": "名前",
  "PORT_NEW_VALUE": "新しい値",
  "PORT_RESTART_NOTICE": "注意: ポート番号の変更を適用するには、サーバーを再起動してください。",
  "PORT_RESTART_SERVER": "サーバーを再起動",
  "PORT_UPDATE_PORTS": "ポートを変更",
  "PORT_WARNING_ADMIN_RESTART": "管理用ポートが変更されました。 {numSecs} 秒後に、新しいページが表示されます。",
  "PREVIEW_MAX_VIDEO_RESOLUTION_360": "360p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_480": "480p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_540": "540p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_720": "720p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_1080": "1080p HD",
  "PROMPT_ARE_YOU_SURE": "実行しますか?",
  "PROMPT_COULD_NOT_CREATE_FOLDER": "このフォルダを作成することができません。 別のパスを入力してください。",
  "PROMPT_COULD_NOT_CREATE_FOLDERS": "次のパスは作成できなかったため、別フォルダのパスを入力してください。",
  "PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT": "同じ名前を持つファイルがすでに存在するため、このフォルダを作成することができません。 別のパスを入力してください。",
  "PROMPT_CREATE_THAT_FOLDER": "このフォルダが存在しません。 作成しますか?",
  "PROMPT_CREATE_THESE_FOLDERS": "このフォルダは存在しません。フォルダを新規作成してよろしいですか?",
  "PROMPT_DELETE_LICENSE_CONFIRM": "選択したライセンスを削除してよろしいですか?",
  "QUERY": "クエリー",
  "REMOVE": "削除",
  "REMOVE_DIRECTORY_SERVICE": "ディレクトリサービスを削除する",
  "REPLACE_USER_MAPPING_CONFIRMATION": "通常のユーザーマッピングが、このユーザーに対してすでに存在しています。 除外ユーザーマッピングで置き換えますか?",
  "REPLACE_USER_EXCLUSION_CONFIRMATION": "除外ユーザーマッピングが、このユーザーに対してすでに存在しています。 通常のユーザーマッピングで置き換えますか?",
  "REQUIRED_FIELD_ERROR": "このフィールドは必須です",
  "REVERT": "元に戻す",
  "REVERT_CHANGES": "変更を元に戻す",
  "ROLE_FOR_IMPORT": "インポートユーザーの役割",
  "ROLES_PERMISSION_ENABLED_HEADER": "使用可能",
  "ROLES_PERMISSION_NAME_HEADER": "操作",
  "SAVE": "保存",
  "SAVE_MAPPING": "マッピングを保存",
  "saveOutputSetting": "プリセットを管理しなさい(改宗者はPDFを作り、)",
  "SEARCH": "検索",
  "SEARCH_BASE": "検索ベース",
  "SEARCH_RESULTS": "検索結果",
  "SECURITY_GROUPS": "セキュリティグループ",
  "SELECT": "選択",
  "SEND_DIAGNOSTIC_DATA": "Portfolio DAMに診断レポートを送信",
  "SERVER_DATA_DEFAULT_WORK_LOCATION_IS": "デフォルトの作業場所",
  "SERVER_RESTART_REQUIRED": "訂正内容を有効にするためには、サーバを再起動する必要があります。",
  "SERVER_STATE_ERROR": "エラー: 管理ログで詳細を見る",
  "SERVER_STATE_STARTED": "動作中",
  "SERVER_STATE_STARTING": "起動しています",
  "SERVER_STATE_STOPPED": "停止しました",
  "SERVER_STATE_STOPPING": "停止しています",
  "SERVER_STATE_UNKNOWN": "不明",
  "SERVICE_BROWSER": "サービスブラウザ",
  "SK_ENGINE_APPAREL": "服装",
  "SK_ENGINE_CELEBRITIES": "名声",
  "SK_ENGINE_FOOD": "食品",
  "SK_ENGINE_GENERAL": "一般",
  "SK_ENGINE_LOGO": "ロゴ",
  "SK_ENGINE_MODERATION": "モデレーション",
  "SK_ENGINE_NSFW": "NSFW",
  "SK_ENGINE_TRAVEL": "旅行",
  "SK_ENGINE_WEDDINGS": "結婚式",
  "SSL_HANDSHAKE_ERROR": "SSL ハンドシェイクに失敗しました。ポートと SSL 設定が正しいことを確認してください。",
  "STARTS_WITH": "で始まる",
  "STATE_OR_PROVINCE": "国または州",
  "STATUS": "ステータス",
  "STATUS_ADMIN_LOG": "管理ログ",
  "STATUS_API_VERSION_LABEL": "API",
  "STATUS_API_STATE_LICENSED": "ライセンスあり",
  "STATUS_API_STATE_UNLICENSED": "ライセンスなし",
  "STATUS_CLEAR_ADMIN_LOG": "管理ログを消去",
  "STATUS_CONNECTED_USERS": "接続ユーザー",
  "STATUS_MAX_ALLOWED_CONNECTIONS": "最大接続数",
  "STATUS_MEDIA_ENGINE_VERSION_LABEL": "Media Engine",
  "STATUS_MEDIA_ENGINES_ACTIVE": "使用可能",
  "STATUS_MEDIA_ENGINES_LABEL": "Media Engine",
  "STATUS_RESTART_SERVER": "Portfolioの再起動",
  "STATUS_SEAT_USAGE": "使用中",
  "STATUS_SERVER_STATE": "Portfolioの状態",
  "STATUS_SERVER_VERSION_LABEL": "Portfolio",
  "STATUS_START_SERVER": "Portfolioの起動",
  "STATUS_STOP_SERVER": "Portfolioの停止",
  "STATUS_PROBLEMS_DETECTED": "検出された問題：",
  "STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM": "起動ディスクの空き容量が {minSpace}GB 以下になっています。",
  "STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST": "作業フォルダが存在しないかアクセスできません。",
  "STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE": "Portfolioは作業フォルダに書き込みできません。",
  "STATUS_MSG_WORK_FOLDER_NOT_READABLE": "Portfolioは作業フォルダから読み取りできません。",
  "STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE": "Portfolioは作業フォルダにシンボリックリンクを作成できません。",
  "STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW": "作業フォルダのあるディスクの空き容量が {minSpace}GB 以下になっています。",
  "STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS": "作業フォルダのステータスを取得できません。",
  "STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED": "Elasticsearchのインデックス {index} のステータスがレッドになっています。",
  "STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS": "Elasticsearchのインデックス {index} に初期化されていないシャードがあります。",
  "STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE": "Elasticsearchのインデックス {index} の全てのシャードがアクティブになっていません。",
  "STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS": "Elasticsearchのステータスを収集できません。",
  "STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER": "Portfolioサーバーからエラーを収集できません。",
  "STATUS_MSG_STARTUP_FAILED": "起動失敗",
  "STATUS_MSG_CANT_GET_SERVER_HEALTH": "サーバーの状態を確認できません",
  "STATUS_MSG_NATIVE_AGENT_NOT_RUNNING": "サーバーのnative-agentコンポーネントが動作していません。",
  "SUBJECT_ALTERNATIVE_NAMES": "サブジェクトの別名（SANs）",
  "SUBMIT": "送信",
  "swedish": "スウェーデン語",
  "SYNC_DAILY": "毎日同期",
  "SYNCHRONIZE_NOW": "同期化を実行",
  "TARGET_CATALOG": "対象カタログ",
  "THIS_LOCALE": "ja",
  "TRUE_LABEL": "真の",
  "TOKEN": "トークン",
  "TOTAL_ASSETS": "アセットの合計",
  "TWO_LETTER_COUNTRY_CODE": "2文字国コード",
  "TYPE": "タイプ",
  "UNABLE_CONNECT_LDAP": "LDAP/AD サーバーに接続できません。",
  "UNABLE_CONNECT_SERVER": "サーバーに接続できません。",
  "UNKNOWN_HOST_ERROR": "不明なホストによる例外が発生したため、ディレクトリサービスに接続できません。 ホスト名を確認してください。",
  "UNKNOWN_LDAP_USER_ERROR": "ID サービスはアカウント名 「{accountName}」 のユーザを見つけられませんでした。",
  "useCustomPresets": "変換プリセットの使用",
  "USE_SSL": "SSL を使用",
  "USER_ACCOUNT": "アカウント",
  "USER_CREATE": "新規ユーザーを追加",
  "USER_DELETE": "ユーザーを削除",
  "USER_DELETE_CONFIRM": "選択したユーザーを削除しますか?",
  "USER_DELETE__DELETE_PRIVATE": "完全に削除します。",
  "USER_DELETE__GALLERY_PROMPT": "パブリックにすると、このユーザーが所有するすべてのプライベートおよび閲覧専用ギャラリーが、パブリックギャラリーになります。 「プライベートギャラリーをすべて削除」は、プライベートギャラリーを完全に削除し、閲覧専用ギャラリーをパブリックにします。",
  "USER_DELETE__GALLERY_PROMPT_1": "ユーザーのチェックアウトアイテムが復帰して、アクセス可能になります。",
  "USER_DELETE__GALLERY_PROMPT_2": "ユーザーの閲覧専用ギャラリーがパブリックになります。",
  "USER_DELETE__GALLERY_PROMPT_3": "ユーザーのプライベートギャラリーを",
  "USER_DELETE__MAKE_PUBLIC": "パブリックにします。",
  "USER_DETAILS": "ユーザーの詳細情報",
  "USER_IMPORT": "ユーザーをインポート",
  "USER_IMPORT_ACCOUNT": "アカウント名",
  "USER_IMPORT_ACCOUNT_ATTR": "アカウントの属性",
  "USER_IMPORT_EMAIL_ATTR": "電子メールの属性",
  "USER_IMPORT_IMPORT": "インポート",
  "USER_IMPORT_IMPORT_SELECTED_USERS": "選択したユーザーをインポート",
  "USER_IMPORT_MODIFY_SEARCH": "検索条件を変更",
  "USER_IMPORT_NAME_ATTR": "アカウント名の属性",
  "USER_IMPORT_NOTES_ATTR": "メモの属性",
  "USER_IMPORT_PASSWORD": "アカウントのパスワード",
  "USER_IMPORT_PASSWORD_ATTR": "パスワードの属性",
  "USER_IMPORT_SEARCH": "検索",
  "USER_IMPORT_SEARCH_BASE": "検索ベース",
  "USER_IMPORT_SEARCH_FILTER": "検索フィルタ",
  "USER_IMPORT_SERVER_ADDRESS": "サーバーのアドレス",
  "USER_IMPORT_SPECIFY_LDAP_SERVER": "LDAP サーバーを指定",
  "USER_LEVEL_ADMINISTRATOR": "カタログ管理者",
  "USER_LEVEL_EDITOR": "編集者",
  "USER_LEVEL_NON_MEMBER": "--",
  "USER_LEVEL_PUBLISHER": "発行者",
  "USER_LEVEL_READER": "閲覧者",
  "USER_MANAGE_CATALOGS": "選択したユーザーに対してカタログを管理",
  "USER_MULT_USERS_SELECTED": "複数のユーザーを選択",
  "USER_NAME": "ユーザー名",
  "USER_NEW_USER_DETAILS": "新規ユーザーの詳細情報",
  "USER_NEW_USER_INFO_MSG": "ユーザーを特定のカタログに追加するには、カタログ > ユーザー。",
  "USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS": "ユーザーを全カタログに追加:",
  "USER_NO_USERS_SELECTED": "ユーザー未選択",
  "USER_ONLINE": "オンライン",
  "USER_PASSWORD_TOO_SHORT": "パスワードには、少なくとも 1 文字が必要です。",
  "USER_PASSWORDS_DO_NOT_MATCH": "確認用パスワードがパスワードと一致しません。",
  "USER_ROLE": "アクセスレベル",
  "USER_VIEW_DETAILS": "ユーザー詳細情報を表示/編集",
  "USERS": "ユーザー",
  "VALIDATION_FIELD_LENGTH_EXCEEDED": "このフィールドは最大 255 文字まで入力できます。",
  "VALIDATION_MUST_BE_NONEMPTY": "このフィールドは必須です。",
  "VIEW_EDIT_MAPPINGS": "マッピングの表示/編集",
  "General.OK": "OK",
  "General.Cancel": "キャンセル",
  "PORT_TITLE": "ポート",
  "PORT_DEFAULT": "デフォルト:",
  "esp.port.admin-web-app": "Portfolioアドミン HTTPポート",
  "esp.port.admin-web-app-ssl": "Portfolioアドミン SSLポート",
  "esp.port.http": "Portfolioサーバー HTTPポート",
  "esp.port.ssl": "Portfolioサーバー SSLポート",
  "General.Save": "保存",
  "CATALOG_DETAILS_FILETYPES_TAB": "ファイルタイプ",
  "addAsset": "アセットを追加",
  "canManageFieldLists": "パブリックフィールドの一覧を管理",
  "canModifyFolderStructure": "フォルダ階層を編集",
  "canMoveAssets": "アセットを移動",
  "deleteAssetContents": "オリジナルアセットの削除",
  "deleteAssetFromCatalog": "カタログからアセットを削除",
  "modifyAssetProperties": "アセットのフィールドを更新",
  "synchronizeAutoSyncFolder": "監視フォルダを同期",
  "ASSETS": "アセット",
  "CATALOG_STORAGE_TYPE_S3": "S3",
  "CREATE_CATALOG": "カタログを作成",
  "STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS": "システムのメモリは{value}GBですが、最小動作環境は{minGB}GBです。",
  "STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE": "Portfolioが計算したシステムのメモリは{value}GBですが、これは正しくない可能性があります。",
  "AUTH.couldNotConnect": "サーバーに接続できません。アドレスを確認してください。",
  "ERROR.serverUnavailable": "Portfolioサーバーを使用できません。",
  "ERROR.sessionExpired": "セッションの期限が切れました。",
  "fileNotFound": "ディスク上にファイルが見つかりません。",
  "ERROR.invalidSearchFailed": "サーバーへのリクエストに問題が発生したため検索に失敗しました。",
  "AUTH.loginFailed": "ユーザー名とパスワードが間違っています。",
  "FAULT_CODE.InsufficientPrivileges": "この操作に必要な権限がありません。",
  "unexpectedError": "予期しないエラーが発生しました。",
  "ROLES_CREATE_ROLE_TITLE": "役割を作成",
  "ROLES_DELETE_CONFIRM": "選択した役割を削除しますか？\nこの役割のユーザーは閲覧者になります。",
  "NOTIFICATION_SUCCESS_UPDATE": "アップデートに成功しました",
  "DATA_COLLECTION_TITLE": "分析",
  "DATA_COLLECTION_RTI_OPT_OUT_LABEL": "私は、アプリケーションの使用データを共有することに同意します。",
  "DATA_COLLECTION_RTI_OPT_OUT_TEXT": "アプリケーションの使用状況を共有して、当社が最適なソリューションを提供できるようにご協力ください。\n\nこれにより、今後の品質や機能の向上に役立つ重要な情報を収集することができます。収集された情報は、お客様のソリューションニーズを理解するのに役立ちます。\n\n情報のご提供はいつでも中止できます。\n\n収集した情報の使用方法や情報提供を中止する方法の詳細については、次の記事をご確認ください。 ",
  "DATA_COLLECTION_HELP_URL": "https://help.portfoliodam.com/hc/ja/articles/360010122274",
  "CREATE_USER": "ユーザーを作成",
  "CATALOG_FILES_TAB_TITLE": "取り込み",
  "FIELD_CATEGORY_ALL": "全使用中フィールド",
  "FIELD_CATEGORY_FONTSENSE": "Portfolio DAM Font Sense",
  "FIELD_DEF.cataloged": "カタログ登録日",
  "FIELD_DEF.catalogedBy": "カタログ登録者",
  "FIELD_DEF.colorMode": "カラーモード",
  "FIELD_DEF.isPanoramic": "パノラマ",
  "FIELD_DEF.created": "作成日",
  "FIELD_DEF.directoryPath": "ディレクトリパス",
  "FIELD_DEF.documentText": "文書テキスト",
  "FIELD_DEF.filename": "ファイル名",
  "FIELD_DEF.fileDescription": "説明",
  "FIELD_DEF.fileSize": "ファイルサイズ",
  "FIELD_DEF.geometry": "Geo - マップ",
  "FIELD_DEF.height": "高さ",
  "FIELD_DEF.horizontalResolution": "水平解像度",
  "FIELD_DEF.keywords": "キーワード",
  "FIELD_DEF.lastModified": "変更日",
  "FIELD_DEF.lastUpdated": "設定日",
  "FIELD_DEF.aliasMac": "Mac エイリアス",
  "FIELD_DEF.creatorMac": "クリエータ (Mac)",
  "FIELD_DEF.fileTypeMac": "ファイルタイプ (Mac)",
  "FIELD_DEF.zoneMac": "AppleTalk ゾーン",
  "FIELD_DEF.multipageCount": "ページ数",
  "FIELD_DEF.numBands": "バンドの番号",
  "FIELD_DEF.path": "パス",
  "FIELD_DEF.ItemID": "アセット ID",
  "FIELD_DEF.shortFilenameWin": "ショートファイル名 (Win)",
  "FIELD_DEF.thumbnailSize": "サムネールのサイズ",
  "FIELD_DEF.updatedBy": "設定者",
  "FIELD_DEF.verticalResolution": "垂直解像度",
  "FIELD_DEF.volume": "ボリューム名",
  "FIELD_DEF.watermarkURL": "透かしの URL",
  "FIELD_DEF.watermarked": "透かし付き",
  "FIELD_DEF.width": "幅",
  "FIELD_DEF.SuggestedKeywords": "Smart Keywords",
  "REFRESH": "更新",
  "ALL_CATALOGS": "すべてのカタログ",
  "ALL_SITES": "すべてのサイト",
  "ASSET_DOWNLOADS": "アセット - 最多ダウンロード",
  "ASSET_PREVIEWS": "アセット - 最多プレビュー",
  "ASSET_UPLOADS": "アセット - アップロード",
  "DOWNLOAD_REPORT": "レポートをダウンロード",
  "FILE_TYPES": "ファイルタイプ",
  "FILE_TYPES_SECTION_TITLE": "ファイルタイプ",
  "FILE_TYPES_ERROR_NAME_EXISTS": "{name}' は既存のファイ",
  "FILE_TYPES_LABEL_RESTORE_DEFAULTS": "初期化",
  "FILE_TYPES_PROMPT_DISCARD_CHANGES": "保留中の変更を破棄しますか？",
  "FILE_TYPES_ADD_FILE_TYPE": "ファイルタイプを追加",
  "FILE_TYPES_UPDATE_FILE_TYPE": "ファイルタイプを更新",
  "FILE_TYPES_EXTENSIONS": "拡張子",
  "FROM": "から",
  "SITE": "サイト",
  "KEYWORD_STATISTICS": "キーワード統計",
  "NETPUBLISH_MOST_DOWNLOADED": "NetPublish - ダウンロード状況",
  "NETPUBLISH_USAGE": "NetPublish - 使用状況",
  "REPORT_DESCRIPTION_ASSET_PREVIEWS": "どのアセットがそれぞれ何回プレビューされたかについてのレポートです。",
  "REPORT_DESCRIPTION_ASSET_UPLOADS": "アップロードされたアセット、アップロードしたユーザー、そしてその日時についてのレポートです。",
  "REPORT_DESCRIPTION_DOWNLOADED": "どのアセットがそれぞれ何回ダウンロードされたかについてのレポートです。",
  "REPORT_DESCRIPTION_KEYWORD": "カタログの全キーワードとそれらが適用されているアセット数についてのレポートです。",
  "REPORT_DESCRIPTION_USAGE": "どのユーザーが何のアセットをいつダウンロードしたかについてのレポートです。",
  "SEARCH_TERMS": "検索語句",
  "TO": "まで",
  "VIEW_REPORT": "レポートを表示",
  "NP_SITES": "NetPublishサイト",
  "REPORT_NAME_DELETED_BY": "アセット - 削除",
  "REPORT_NAME_DOWNLOADED_BY": "アセット - ダウンロード",
  "REPORT_DESCRIPTION_DELETED_BY": "削除されたアセット、削除したユーザー、そしてその日時についてのレポートです。",
  "REPORT_DESCRIPTION_DOWNLOADED_BY": "ダウンロードされたアセット、ダウンロードしたユーザー、そしてその日時についてのレポートです。",
  "CATALOG_SAVE_TEMPLATE_TITLE": "カタログテンプレートを作成",
  "BACKUP_FILES_LABEL": "バックアップファイル",
  "CONFIGURE_EMAIL_LINK": "Email通知を設定",
  "NP_SOURCE": "ソース",
  "NOTIFICATION_FAILURE_UPDATE": "アップデートに失敗しました",
  "FIELD_FORM_LABEL_PRECISION_MAX": "最大",
  "REPORT_DESCRIPTION_FILE_TYPES": "最も一般的なファイルタイプとそのディスク容量についてのレポートです。",
  "REPORT_DESCRIPTION_SEARCH_TERMS": "最も一般的な検索語句についてのレポートです。",
  "DUPLICATE_FIELD_NAME_ERROR": "フィールド名を複製",
  "NO_CATALOGS_EXIST": "カタログがありません。\n\n+ボタンをクリックしてカタログを作成してください。",
  "CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS": "役割を変更します",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE": "メンバシップを取り消し",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG": "カタログからユーザーを削除しますか？\nユーザーのこのカタログのチェックアウトアイテムが復帰して、アクセス可能になります。",
  "CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG": "本当にユーザーの役割を変更しますか？変更後の役割に許可されている機能が少ないと、ユーザーのデータが失われる可能性があります。",
  "DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE": "問い合わせ中です。数分かかる可能性があります。",
  "FIELD_DELETE_CONFIRM_MSG": "選択したフィールドを削除しますか？",
  "FILE_TYPES_PROMPT_RESTORE_DEFAULTS": "全てのファイルタイプを初期化しますか？",
  "DIRECTORY_SERVICE_BROWSE_FILTER_LABEL": "フィルタ",
  "DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL": "AD ユーザーとグループ",
  "DIRECTORY_SERVICE_SAVE_MAPPINGS": "保存して同期",
  "DIRECTORY_SERVICE_REMOVE_MAPPING": "マッピングを削除",
  "DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL": "Portfolioユーザーの取り込み",
  "DIRECTORY_SERVICE_NO_MAPPINGS_LABEL": "マッピングがありません。\n\nユーザーかグループを選択して「マッピングを作成」をクリックしてください。",
  "NOTIFICATION_FAILURE_ADD": "追加失敗",
  "FIELD_ADD_EXTRACT_METADATA": "抽出マッピングを追加",
  "FIELD_MULTIPLE_EMBED_WARNING": "複数のフィールドが に埋め込まれます",
  "CATALOG_SK_KEYWORD_ON_CATALOG_LABEL": "カタログに新規登録されたアセットにSmart Keywordを追加",
  "LIC_CLICK_TO_UPGRADE": "Portfolio Serverをアップグレードするにはクリックします。",
  "LIC_MAINTENANCE_END_DATE": "メンテナンス/サブスクリプションの終了日",
  "LIC_SEAT_DISPLAY": "シートを使用",
  "LIC_ACTIVATE": "Portfolioをアクティベート (要認証情報)",
  "LIC_CLICK_TO_ACTIVATE": "Portfolio Serverをアクティベートするにはクリックします。",
  "LIC_CLICK_TO_USE": "Portfolioを一時的に使用するにはクリックします。",
  "LIC_TRIAL": "Portfolioを試用 (要シリアル番号)",
  "EXTENSIS_CONTACT_US_URL": "https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option",
  "EXTENSIS_SUPPORT_URL": "https://help.portfoliodam.com/hc/en-us/requests/new",
  "LIC_ERROR_GET_ACCOUNT": "Portfolio DAMアカウントの取得に問題が発生しました。",
  "LIC_ERROR_GET_LICENSES": "Portfolio DAMからライセンスを復帰するのに問題が発生しました。",
  "CHANGE": "変更",
  "GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE": "このフォルダを変更するには、Portfolioサーバーを終了してください。",
  "MEDIA_ENGINES_COLUMN_TEST": "テスト",
  "ROLES_PERMISSIONS": "許可",
  "NO_SITES_EXIST_1": "NetPublishサイトがありません",
  "NO_SITES_EXIST_2": "Portfolio WebのPublishオプションを使用して、サイトを作成して発行してください。",
  "MEDIA_ENGINE_NOT_OPERATIONAL": "Media Engineは利用不可です。",
  "MEDIA_ENGINE_OPERATIONAL": "Media Engineは稼働中です。",
  "LIC_SET_EXTENSIS_ACCOUNT": "Portfolio DAMアカウントを設定",
  "LIC_ACCOUNT": "電子メールアドレス",
  "LIC_PASSWORD": "パスワード",
  "CERTS_TITLE": "SSL証明書",
  "LIC_SYSTEM_ID": "システムID",
  "LIC_SET_ACCOUNT_ERROR": "Portfolio DAMアカウントの設定に問題が発生しました。認証情報を確認して再度お試しください。",
  "LIC_SET_SYSTEM_TITLE": "Portfolio DAMシステムを選択",
  "NP_DELETE_SITE_CONFIRMATION": "サイトを完全に削除しますか？",
  "NP_SITE_DELETE_LABEL": "サイトを削除",
  "NP_SITE_ENABLED_LABEL": "有効サイト",
  "CERT_CREATE_REQUEST": "証明書要求を作成",
  "CERT_DOWNLOAD": "ダウンロード",
  "CERT_EXPIRATION_DATE": "有効期限",
  "CERT_IMPORT": "証明書を取り込む",
  "CERT_ISSUER": "発行元",
  "CERT_OWNER": "所有者",
  "CERT_PENDING_REQUEST": "保留中の証明書リクエスト",
  "CERTIFICATE_STATUS_INVALID": "無効な証明書",
  "CERTIFICATE_STATUS_SELF_SIGNED": "無効な証明書：自己署名",
  "CERTIFICATE_STATUS_EXPIRED": "証明書の期限が切れています",
  "CERTIFICATE_STATUS_IMPORTED": "証明書が取り込まれています",
  "CERT_DELETE_CONFIRMATION": "証明書リクエストを本当に削除しますか？ この操作は取り消しできません。",
  "DIAGNOSTICS_TITLE": "診断",
  "DIAGNOSTICS_NO_PROBLEMS": "問題なし",
  "SK_ENGINE_ART_STYLE": "アートスタイル",
  "SK_ENGINE_ART_SUBJECT": "アート科目",
  "SK_ENGINE_ART_MOVEMENT": "アートムーブメント",
  "CERT_FILE": "証明書ファイル",
  "CERT_FILE_INT_1": "中間証明書 1",
  "CERT_FILE_INT_2": "中間証明書 2",
  "CERT_FILE_PASSWORD": "証明書パスワード",
  "CERT_FILE_PASSWORD_HELP": "証明書にパスワードが設定されている場合はここに入力します",
  "CERT_FILE_PROMPT": "選択",
  "CERT_FILE_ROOT": "ルート証明書",
  "CERT_IMPORT_SUCCEEDED": "証明書の取り込みに成功しました。証明書を使用するには、PortfolioサーバーとPortfolio adminサービスを再起動します。",
  "CERT_IMPORT_FAILED_READING_PKCS12": "PKCS12証明書を取り込めませんでした。パスワードを確認してください。",
  "CERT_IMPORT_FAILED_INTERMEDIATE1": "中間証明書を取り込めませんでした。",
  "CERT_IMPORT_FAILED_INTERMEDIATE2": "中間証明書を取り込めませんでした。",
  "CERT_IMPORT_FAILED_ROOT": "ルート証明書を取り込めませんでした。",
  "DIRECTORY_SERVICE_CONFIG_TITLE": "ディレクトリサービスの設定",
  "DIRECTORY_SERVICES_TITLE": "ディレクトリサービス",
  "DIRECTORY_SERVICE_MAPIINGS": "Portfolioマッピングのディレクトリアイテム",
  "DIRECTORY_SERVICE_MAPIINGS_TITLE": "マッピング",
  "PDL_noPredefinedValues": "定義済みの値なし",
  "PDL_editPredefinedListPlaceholder": "定義済みの値のリストを編集",
  "PDL_importPredefinedValues": "定義済みの値を読み込む",
  "PDL_exportPredefinedValues": "定義済みの値を書き出す",
  "PDL_removeNestedValueConfirmation": "選択した値を削除しますか？\n選択した値に含まれる下位の値も一緒に削除されます。",
  "PDL_wrongPdlImportFormat": "選択したファイルにはテキストデータがありませんでした。テキストファイルを選択してください。",
  "LIC_SET_ACCOUNT": "アカウントを設定",
  "LIC_REMOVE_ACCOUNT": "アカウントを削除",
  "LIC_CONTACT_CUSTOMER_SUCCESS_1": "アカウントの更新についてサポートが必要な場合は、",
  "LIC_CONTACT_CUSTOMER_SUCCESS_2": "までご連絡ください。カスタマーサクセスマネージャーから1営業日以内にご連絡いたします。"
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/translations/ja.js